"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var TumblrBox = function TumblrBox(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "inherit",
    id: "path-3-tumblr-box" + unique,
    points: "0 0 12.9978 0 12.9978 10.5618 0 10.5618"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/tumblr_box-tumblr-box" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-tumblr-box" + unique,
    xlinkHref: "#path-1-tumblr-box" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-tumblr-box" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M15.9432624,10.9574468 L15.9432624,7.9787234 L12.964539,7.9787234 L12.964539,5 L10.7801418,5 C10.5815603,6.19148936 10.3829787,7.9787234 8,8.17730496 L8,10.9574468 L9.9858156,10.9574468 C9.9858156,10.9574468 9.9858156,14.4326241 9.9858156,15.6241135 C9.9858156,17.4113475 11.2765957,19 13.858156,19 C14.9503546,19 15.9432624,18.9007092 15.9432624,18.9007092 L15.9432624,15.9219858 C15.9432624,15.9219858 14.9503546,15.9219858 14.0567376,15.9219858 C13.0638298,15.9219858 12.964539,15.5248227 12.964539,14.8297872 C12.964539,14.7304965 12.964539,10.9574468 12.964539,10.9574468 L15.9432624,10.9574468 Z",
    fill: "inherit",
    id: "path-1-tumblr-box" + unique
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "page-1-tumblr-box" + unique,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    transform: "translate(22.000000, 23.000000)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    fill: "none",
    id: "mask-4-tumblr-box" + unique
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    xlinkHref: "#path-3-tumblr-box" + unique
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "clip-2-tumblr-box" + unique,
    stroke: "none"
  })))));
};

TumblrBox.propTypes = propTypes;
var _default = TumblrBox;
exports["default"] = _default;